import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import RestClient from '../../../services/client/RestClient'
import CompanyConfig from '../../../services/api/CompanyConfig'
import Configuration from '../../../services/api/Configuration'

const { Company_Endpoints } = CompanyConfig

const getCompaniesModulesApi = Configuration.Company_Endpoints.modules
const addCompanyApi = Configuration.Company_Endpoints.add
const lastTenantApi = Configuration.Company_Endpoints.lastTenant
const getFabsTenantsApi = Configuration.Company_Endpoints.fabsTenants
const ssoAddCompanyConfigApi = (id) => Configuration.Company_Endpoints.ssoAddCompanyConfig(id)
const ssoFetchMetadataApi = (id) => Configuration.Company_Endpoints.ssoFetchMetadata(id)

const resetState = {
  pageNumber: 0,
  activeFilters: [],
  activeSearch: '',
  updatedItem: {},
}

export const companiesResetAlertHandler = createAsyncThunk(
  'companies/companiesResetAlertHandler',
  async () => ({}),
)

export const showCompanySnackbar = createAsyncThunk(
  'companies/showCompanySnackbar',
  async ({ message, variant = 'error' }) => ({ message, variant }),
)

export const retrieveCompanies = createAsyncThunk(
  'companies/retrieveCompanies',
  async ({ queries, resetQueries }, { getState, rejectWithValue }) => {
    const apiUri = Company_Endpoints();
    const { companies } = getState()
    const endpoint = apiUri.list;
    const queryString = createReqHelper(companies, resetQueries ? resetState : queries)
    const response = await RestClient.getRequest(
      `${endpoint}?${queryString}`,
    )
    if (response.status >= 300) {
      return rejectWithValue(response);
    }
    return {
      response: response.data,
      queries: resetQueries ? resetState : queries,
    };
  },
)

export const retrieveCompanyDetails = createAsyncThunk(
  'companies/retrieveCompanyDetails',
  async ({ id }, { rejectWithValue }) => {
    const apiUri = Company_Endpoints(id)
    const endpoint = apiUri.details
    const response = await RestClient.getRequest(endpoint)
    if (response.status >= 300) {
      return rejectWithValue(response)
    }
    return {
      response: response.data,
    }
  },
)

export const addCompany = createAsyncThunk('companies/addCompany', async ({
  body,
}, { rejectWithValue }) => {
  const response = await axios.post(addCompanyApi, body)
  if (response.status >= 300) {
    return rejectWithValue(response)
  }
  return response.data
})

export const editCompany = createAsyncThunk('companies/editCompany', async ({
  body,
  id,
}, { rejectWithValue }) => {
  const response = await axios.put(`${addCompanyApi}/${id}`, body)
  if (response.status >= 300) {
    return rejectWithValue(response)
  }
  return response.data
})

export const companyChangeStatus = createAsyncThunk(
  'companies/changeStatus',
  async ({ queries }, { rejectWithValue }) => {
    const module_ids = []
    queries.data.modules?.forEach((singleModule) => {
      module_ids.push(singleModule.id)
    })

    let body
    if (queries.title === 'Active') {
      body = { active: true, suspended: false, name: queries.data.name, module_ids }
    } else if (queries.title === 'Disabled') {
      body = { active: false, suspended: false, name: queries.data.name, module_ids }
    } else if (queries.title === 'Suspended') {
      body = { active: false, suspended: true, name: queries.data.name, module_ids }
    }
    const apiUri = Company_Endpoints(queries.data.id);
    const endpoint = apiUri.add;
    const response = await axios.put(endpoint, body)

    if (response.status >= 300) {
      return rejectWithValue(response)
    }

    return {
      response: response.data,
    };
  },
)

export const ssoAddCompanyConfig = createAsyncThunk('companies/ssoAddCompanyConfig', async ({ body, id }, { rejectWithValue }) => {
  const response = await axios.post(`${ssoAddCompanyConfigApi(id)}`, body)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const ssoEditCompanyConfig = createAsyncThunk('companies/ssoEditCompanyConfig', async ({ body, id }, { rejectWithValue }) => {
  const response = await axios.put(`${ssoAddCompanyConfigApi(id)}`, body)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const ssoGetCompanyConfig = createAsyncThunk('companies/ssoGetCompanyConfig', async ({ id }, { rejectWithValue }) => {
  const response = await axios.get(`${ssoAddCompanyConfigApi(id)}`)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const ssoFetchCompanyMetadata = createAsyncThunk('companies/ssoFetchCompanyMetadata', async ({ id, body }, { rejectWithValue }) => {
  const response = await axios.post(`${ssoFetchMetadataApi(id)}`, body)

  if (response.status >= 300) {
    return rejectWithValue(response)
  }

  return response.data
})

export const lastTenant = createAsyncThunk('companies/lastTenant', async () => {
  const response = await RestClient.getRequest(lastTenantApi)
  return response.data
})

export const retrieveCompaniesModules = createAsyncThunk('companies/modules', async () => {
  const res = await RestClient.getRequest(`${getCompaniesModulesApi}`)

  return res?.data
})

export const retrieveCompaniesFabsTenants = createAsyncThunk('companies/fabsTenants', async () => {
  const res = await RestClient.getRequest(`${getFabsTenantsApi}`)
  return res?.data
})

function createReqHelper(store, filters = {}) {
  const copyStore = { ...store, ...filters };

  const {
    pageSize,
    pageNumber,
    activeSort,
    activeSearch,
    activeSummary,
  } = copyStore;

  return [
    `page_number=${pageNumber || 0}`,
    `page_size=${pageSize || 9}`,
    `sort_by=${activeSort?.key || ''}`,
    `data_status=${activeSummary || ''}`,
    `search=${activeSearch || ''}`,
  ].join('&');
}
